import { API_URL } from './Constants';
import ApiService from './ApiService';

class HinhanhPageApi {
    static getListHinhAnh = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/hinh-anh/list");
        } catch (error) {
        }
    };

    static getChiTietHinhAnh = async (postId) => {
        let params = {};
        if (postId !== null) {
            params = { postId };
        }
        try {
            return await ApiService.getDataWithParams(API_URL + "/hinh-anh/chi-tiet", params);
        } catch (error) {
        }
    };

    static getAllType = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/hinh-anh/all-type");
        } catch (error) {
        }
    };

    static getListByCat = async (catId) => {
        try {
            let params = {};
            if (catId !== null) {
                params = { catId };
            }
            return await ApiService.getDataWithParams(API_URL + "/hinh-anh/list-by-cat", params);
        } catch (error) {
        }
    };

    // --------------- ADMIN -----------------
    static submitPost = async (formData) => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }

        if (formData.image) {
            data.append("image", formData.image); // Add image if available
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/hinh-anh/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("isDeleteFile", formData.isDeleteFile);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }

        if (formData.image) {
            data.append("image", formData.image); // Add image if available
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/hinh-anh/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietTintucAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };
            return await ApiService.getDataWithParams(API_URL + "/hinh-anh/detail", params);
        } catch (error) {
        }
    };

    //  ---------------------- MEDIA -----------------------
    static createMedia = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("description", formData.description);

        if (formData.image) {
            data.append("image", formData.image); // Add image if available
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/hinh-anh/media/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}

export default HinhanhPageApi;